
export default function CurrencyFormatter (value, currency='KES') {
	try {
		return new Intl.NumberFormat("en-US", {style: "currency", currency: currency}).format(value);
	} catch (e) {
		
	}
}